import { useContext } from "react";
import FormContext from "../../context/FormContext.js";
import { FormContainer as Container, FormSection as Section } from "../../components/index.js";
import { InputField as Input } from "../../components/index.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import StaticDataContext from "../../context/StaticDataContext.js";
import { createList } from "../../utils/utils.js";

export default function PreferredNamePronoun() {
    const { formData } = useContext(FormContext);
    const { staticData } = useContext(StaticDataContext);
    const { injectFormProps } = useInjectFormProps();
    return (
        <Container>
            {injectFormProps(
                <>
                    <Section title={"Consent For Use of Preferred Name or Pronoun(s)"}>
                        <Input type={"radiooptions"} inputLabel={"Please select one of the following"} identifier={"hasPreferedPronounName"}
                            options={[{
                                label: "Not applicable.",
                                value: "no"
                            }, {
                                label: "I/We would like to give consent on the use of preferred name(s).",
                                value: "onlyName"
                            }, {
                                label: "I/We would like to give consent on the use of pronoun(s).",
                                value: "onlyPronoun"
                            }, {
                                label: "I/We would like to give consent on the use of preferred name and pronoun(s).",
                                value: "both"
                            }]} />
                        {
                            (formData["hasPreferedPronounName"] !== "no" && formData["hasPreferedPronounName"]) &&
                            <>
                                <hr />
                                <Input type={"text"} disabled inputLabel={"I (we), the undersigned, consent that:"} mandatory={false} 
                                value={formData["studentFirstName"] ? formData["studentFirstName"] + " " + formData["studentLastName"] + " " + formData["studentLegalSuffix"] : ""}></Input>
                            </>
                        }
                        {
                            (formData["hasPreferedPronounName"] === "onlyName" || formData["hasPreferedPronounName"] === "both") &&
                            <>

                                {
                                    (formData["hasPreferredName"] === "1")
                                        ?
                                        <Input type={"text"} disabled inputLabel={"be referred to by the following name(s):"} mandatory={false}
                                            value={
                                                formData["studentPrefFirstName"]
                                                + (formData["studentPrefMiddleName"] ? ` ${formData["studentPrefMiddleName"]}` : "")
                                                + (formData["studentPrefLastName"] ? ` ${formData["studentPrefLastName"]}` : "")
                                                + (formData["studentPrefSuffix"] ? ` ${formData["studentPrefSuffix"]}` : "")}></Input>
                                        : <>
                                            <p>be referred to by the following name(s):</p>
                                            <b><i>No preferred names entered in Section 1.</i></b>
                                        </>
                                }
                            </>

                        }
                        {
                            (formData["hasPreferedPronounName"] === "onlyPronoun" || formData["hasPreferedPronounName"] === "both") &&
                            <>
                                <Input type={"select"} inputLabel={"be referred to by the following pronoun(s):"} identifier={"prefPronouns"} options={createList(staticData, "pronoun")}></Input>
                                {
                                    formData["prefPronouns"] === "Other" &&
                                    <Input type={"text"} inputLabel={"Enter pronouns"} identifier={"otherPrefPronoun"} />
                                }
                            </>
                        }
                        {(formData["hasPreferedPronounName"] !== "no" && formData["hasPreferedPronounName"]) &&
                            <>
                                {/* {
                                formData["prefNameOptions"] === "other" && <>
                                    <hr />
                                    <Input type={"noyesradio"} inputLabel={"Consent that the above change(s) be reflected on the student’s official record."}
                                        identifier={"consentReflectOfficialRecord"}
                                    ></Input>
                                    </>
                                    } */}
                                <hr />
                                <Input type={"text"} inputLabel={<>{formData["registrantType"] === "PG" ? "Parent/Guardian" : "Student"} Signature</>} value={formData["registrantName"] ?? "N/A"} disabled></Input>
                                {formData["registrantType"] === "PG" &&
                                    <Input type={"text"} inputLabel={"Second Parent/Guardian Signature (optional)"} mandatory={false}></Input>
                                }
                                <hr />
                                <Input type={"checkbox"}
                                    inputLabel={<span>I understand that the above information will be reflected in the <b>student’s records</b>, <b>including attendance</b>, <b>report cards</b>, and <b>class lists</b>.</span>}
                                    identifier={"consentReflectOfficialRecord"} />
                                <Input type={"checkbox"}
                                    inputLabel={<span>I acknowledge that the student’s <b>legal name</b> will appear on all <b>transcripts</b>.</span>}
                                    identifier={"consentReflectTranscript"} />
                                <Input type={"checkbox"} inputLabel={"I confirm that all the above information is correct and accurate."} identifier={"prefPronounNameAgree"}></Input>
                            </>}
                    </Section >
                </>
            )
            }
        </Container >
    );
}
